/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiMetricFromJSON, ApiMetricToJSON, } from './ApiMetric';
export function ApiIncrementalityPrimaryMetricResultFromJSON(json) {
    return ApiIncrementalityPrimaryMetricResultFromJSONTyped(json, false);
}
export function ApiIncrementalityPrimaryMetricResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'confidenceIntervalLower': !exists(json, 'confidenceIntervalLower') ? undefined : json['confidenceIntervalLower'],
        'confidenceIntervalUpper': !exists(json, 'confidenceIntervalUpper') ? undefined : json['confidenceIntervalUpper'],
        'confidenceLevel': !exists(json, 'confidenceLevel') ? undefined : json['confidenceLevel'],
        'expectedValue': !exists(json, 'expectedValue') ? undefined : json['expectedValue'],
        'impactPercentage': !exists(json, 'impactPercentage') ? undefined : json['impactPercentage'],
        'impactValue': !exists(json, 'impactValue') ? undefined : json['impactValue'],
        'metric': !exists(json, 'metric') ? undefined : ApiMetricFromJSON(json['metric']),
        'observedValue': !exists(json, 'observedValue') ? undefined : json['observedValue'],
        'pValue': !exists(json, 'pValue') ? undefined : json['pValue'],
        'statisticallySignificant': !exists(json, 'statisticallySignificant') ? undefined : json['statisticallySignificant'],
    };
}
export function ApiIncrementalityPrimaryMetricResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'confidenceIntervalLower': value.confidenceIntervalLower,
        'confidenceIntervalUpper': value.confidenceIntervalUpper,
        'confidenceLevel': value.confidenceLevel,
        'expectedValue': value.expectedValue,
        'impactPercentage': value.impactPercentage,
        'impactValue': value.impactValue,
        'metric': ApiMetricToJSON(value.metric),
        'observedValue': value.observedValue,
        'pValue': value.pValue,
        'statisticallySignificant': value.statisticallySignificant,
    };
}
